import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../../hoc/Localization';
import styles from './styles.less';

const SalaryRangeWeb = ({ salary }) => {
  const { t } = React.useContext(LocalizationContext);
  return (
    <>
      {salary && salary.length === 4 && (
        <>
          <div className={styles.salaryText}>
            <h3>{t('paths.experience.salary')}</h3>
            <p>{t('paths.expected.time')}</p>
          </div>
          <div className={styles.salaryGraph}>
            <div className={styles.salaryGraphFirst}>
              <p>{salary[0].title}</p>
              <div className={styles.firstShape} />
              <p>
                {t('path.up.to')}
                {' '}
                {salary[0].amountEnd}
                {' '}
                AMD
              </p>
              <p>
                {salary[0].experienceEnd}
                {' '}
                {salary[0].period}
              </p>
            </div>
            <div className={styles.salaryGraphMiddle}>
              <p>{salary[1].title}</p>
              <div className={styles.secondShape} />
              <p>
                {salary[1].amountStart}
                {' '}
                -
                {' '}
                {salary[1].amountEnd}
                {' '}
                AMD
              </p>
              <p>
                {salary[1].experienceStart}
                {' '}
                {t('path.to')}
                {' '}
                {salary[1].experienceEnd}
                {' '}
                {salary[1].period}
              </p>
            </div>
            <div className={styles.salaryGraphMiddle}>
              <p>{salary[2].title}</p>
              <div className={styles.thirdShape} />
              <p>
                {salary[2].amountStart}
                {' '}
                -
                {' '}
                {salary[2].amountEnd}
                {' '}
                AMD
              </p>
              <p>
                {salary[2].experienceStart}
                {' '}
                {t('path.to')}
                {' '}
                {salary[2].experienceEnd}
                {' '}
                {salary[2].period}
              </p>
            </div>
            <div className={styles.salaryGraphLast}>
              <p>{salary[3].title}</p>
              <div className={styles.forthShape} />
              <p>
                {salary[3].amountStart}
                {' '}
                -
                {' '}
                {salary[3].amountEnd}
                {' '}
                AMD
              </p>
              <p>
                {salary[3].experienceStart}
                {' '}
                {t('path.to')}
                {' '}
                {salary[3].experienceEnd}
                {' '}
                {salary[3].period}
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

SalaryRangeWeb.propTypes = {
  salary: PropTypes.object.isRequired,
};

export default SalaryRangeWeb;
